import React, { useContext } from 'react'
import { Button, Carousel, Container } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { UserContext } from '../context'
import PricePlans from './PricePlans'

import portada from '../assets/img/portada_feed.jpg'
import portada_3 from '../assets/img/portada_feed_3.jpg'
import portada_4 from '../assets/img/portada_feed_4.jpg'
import clase from '../assets/img/yoga_clase.webp'

import fuerte from '../assets/img/fuerte.png'
import cerebro from '../assets/img/cerebro.png'
import brillar from '../assets/img/brillar.png'
import benefits_pose_sandra from '../assets/img/benefits_pose_sandra.jpeg'

import './Landing.css'

export default function Landing({ isLoggedIn, trialDays }) {
  return (
    <>
      <HeroCarousel trialDays={trialDays} />
      <TrustStrip />
      <VideoPresentation />
      <Benefits />
      <div className="section section--soft">
        <PricePlans />
      </div>
      <YogaSchoolInfo />
    </>
  )
}

/* =========================
   HERO
========================= */
function HeroCarousel({ trialDays }) {
  const [state] = useContext(UserContext)
  const isActive = !!state?.user?.active

  const slides = [
    {
      id: 1,
      image: portada,
      title: 'Encuentra calma y claridad',
      subtitle:
        'Clases guiadas de Kundalini y Hatha para reconectar contigo mismo, estés donde estés.',
    },
    {
      id: 2,
      image: portada_3,
      title: 'Una práctica a tu ritmo',
      subtitle:
        'Elige entre sesiones cortas y programas completos para crear tu ritual personal.',
    },
    {
      id: 3,
      image: portada_4,
      title: 'Respira, fluye, descansa',
      subtitle:
        'Mejora tu fuerza, enfoque y serenidad con nuestra biblioteca de clases.',
    },
  ]

  const trialCopy =
    Array.isArray(trialDays) && trialDays[0]?.days
      ? `Prueba ${trialDays[0].days} días gratis`
      : 'Empieza ahora'

  return (
    <div className="hero">
      <Carousel fade indicators interval={7000} className="hero__carousel">
        {slides.map((s) => (
          <Carousel.Item key={s.id} className="hero__slide">
            <img src={s.image} alt={s.title} className="hero__image" />

            <div className="hero__overlay" />

            <div className="hero__content">
              <p className="hero__eyebrow">SAT NAM • YOGA ESTUDIO</p>
              <h1 className="hero__title">{s.title}</h1>
              <p className="hero__subtitle">{s.subtitle}</p>

              {!isActive && (
                <div className="hero__ctas">
                  <LinkContainer to="/payment-methods">
                    <Button className="cta cta--primary">{trialCopy}</Button>
                  </LinkContainer>
                  <LinkContainer to="/videos">
                    <Button className="cta cta--ghost">Explorar clases</Button>
                  </LinkContainer>
                </div>
              )}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  )
}

/* =========================
   TRUST / STATS
========================= */
function TrustStrip() {
  const items = [
    { k: '250+', v: 'Clases en video' },
    { k: '10+', v: 'Maestros certificados' },
    { k: '24/7', v: 'Acceso en cualquier dispositivo' },
  ]
  return (
    <div className="trust">
      <Container className="trust__wrap">
        {items.map((i, idx) => (
          <div key={idx} className="trust__item">
            <div className="trust__k">{i.k}</div>
            <div className="trust__v">{i.v}</div>
          </div>
        ))}
      </Container>
    </div>
  )
}

/* =========================
   VIDEO PRESENTATION
========================= */
function VideoPresentation() {
  return (
    <section className="section">
      <Container className="videoCard">
        <div className="videoCard__text">
          <h2 className="section__title">Bienvenido a Sat Nam</h2>
          <p className="section__lead">
            Una escuela de yoga en línea y presencial en Guadalajara, enfocada
            en cultivar serenidad, fuerza y claridad mental.
          </p>
        </div>
        <div
          className="videoCard__media"
          style={{ padding: '56.25% 0 0 0', position: 'relative' }}
        >
          <iframe
            src="https://player.vimeo.com/video/931506664?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
            title="Bienvenida"
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              borderRadius: '16px',
            }}
          />
        </div>
      </Container>
    </section>
  )
}

/* =========================
   BENEFITS
========================= */
function Benefits() {
  const items = [
    {
      id: 1,
      icon: fuerte,
      title: 'Cuerpo fuerte y flexible',
      text:
        'Secuencias que equilibran fuerza y movilidad, con enfoque consciente en la respiración.',
    },
    {
      id: 2,
      icon: cerebro,
      title: 'Mente clara y enfocada',
      text:
        'Meditaciones y respiraciones para soltar tensión mental y cultivar presencia.',
    },
    {
      id: 3,
      icon: brillar,
      title: 'Energía renovada',
      text:
        'Hábitos que revitalizan y sostienen tu práctica diaria con suavidad y disciplina.',
    },
  ]

  return (
    <section className="section section--fade">
      <Container className="benefitsGrid">
        <div className="benefitsGrid__media">
          <img src={benefits_pose_sandra} alt="Postura de yoga" />
        </div>

        <div className="benefitsGrid__list">
          {items.map((b) => (
            <article key={b.id} className="benefitCard">
              <div className="benefitCard__icon">
                <img src={b.icon} alt={b.title} />
              </div>
              <div>
                <h3 className="benefitCard__title">{b.title}</h3>
                <p className="benefitCard__text">{b.text}</p>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  )
}

/* =========================
   ABOUT / SCHOOL INFO
========================= */

function YogaSchoolInfo() {
  return (
    <section className="section section--about">
      <Container className="about">
        <div className="about__copy">
          <h2 className="section__title">
            Únete en Guadalajara o desde casa
          </h2>
          <p className="section__body">
            En el corazón de Guadalajara ofrecemos clases presenciales que
            integran mente, cuerpo y espíritu. Si prefieres la flexibilidad,
            nuestra suscripción en línea te da acceso a una biblioteca de clases
            guiadas por maestros experimentados. Diseña un camino de práctica
            que se adapte a tu vida cotidiana.
          </p>
          <div className="about__ctas">
            <LinkContainer to="/contact-form">
              <Button variant="outline-primary" className="cta cta--ghost">
                Más información
              </Button>
            </LinkContainer>
            <LinkContainer to="/payment-methods">
              <Button className="cta cta--primary">Suscríbete ahora</Button>
            </LinkContainer>
          </div>
        </div>

        <div className="about__media">
          <img src={clase} alt="Clase de yoga en Sat Nam" loading="lazy" />
        </div>
      </Container>
    </section>
  );
}

